import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import adminRoutes from "routes/admin-routes";
import PageHeader from "./sections/PageHeader";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import footerRoutes from "footer.routes";
import DefaultFooter from "components/DefaultFooter";
import ContainerCard from "components/ContainerCard";

import Container from "@mui/material/Container";
import Explanation from "./sections/Explanation";
import PriceModificationForm from "./components/PriceModificationForm";
import SettingModificationForm from "./components/SettingModificationForm";
import SubscriptionModificationForm from "./components/SubscriptionModificationForm";
import Breadcrumbs from "examples/Breadcrumbs";

function ChatbotDefaults() {
  return (
    <>
      <DefaultNavbar routes={adminRoutes} />
      <PageHeader />
      <ContainerCard>
        <Container>
          <Breadcrumbs routes={[{ label: "Admin", route: "/admin" }, { label: "Prijzen" }]} />
          <Explanation />
          <MKTypography variant="h3" py={2}>
            Prijzen
          </MKTypography>
          <PriceModificationForm
            productKey="one-time-access"
            title="Eenmalige toegang (zonder abonnement)"
            description="De prijs voor eenmalige toegang als de gebruiker geen maandelijks abonnement heeft."
          />
          <PriceModificationForm
            productKey="one-time-access-discounted"
            title="Eenmalige toegang (met abonnement)"
            description="De prijs voor eenmalige toegang als de gebruiker wel een maandelijks abonnement heeft."
          />

          <MKTypography variant="h3" py={2}>
            Abonnement
          </MKTypography>
          <PriceModificationForm
            productKey="subscription-standard-monthly"
            title="Maandelijks abonnement"
            description="De prijs voor een maandelijks abonnement."
          />

          <SubscriptionModificationForm
            productKey="subscription-standard-monthly"
            title="Maandelijks abonnement tegoed"
            description="Het aantal gratis gesprekken dat een gebruiker met een abonnement iedere maandkrijgt."
          />

          <MKTypography variant="h3" py={2}>
            Welkomstcadeau
          </MKTypography>
          <SettingModificationForm
            settingKey="free-credits-on-signup"
            title="Gratis tegoed bij aanmelding"
            description="Het aantal gratis gesprekken dat een gebruiker krijgt als welkomstcadeau om de chatbot uit te proberen."
          />
        </Container>
      </ContainerCard>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ChatbotDefaults;
